import React, { Component } from 'react';
import {connect} from 'react-redux';
import ReactTable from 'react-table';

import {
	Card,
	CardBody,
	CardTitle,
	Button,
} from 'reactstrap';

import {
	API_BASE_URL
} from '../../helpers/constants';
import {I18n} from '../../I18n/components/checkedAppsList';
import 'react-table/react-table.css';
import './checkedAppsList.css';

class CheckedAppsList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOkModal: false,
			checkedApps: [],
			loading: true,
		};
	}

	componentDidMount() {
		this.setState({
			checkedApps: this.props.checkedApps,
			loading: false
		});
	}

	unselectApp = appId => {
		this.setState(state => ({
			checkedApps: state.checkedApps.filter(app => app.id !== appId)
		}),() => {
			this.props.uncheckedApp(appId);
		});
	};

	unselectAllApp = () => {
		this.setState(state => ({
			checkedApps: []
		}),() => {
			this.props.uncheckedAllApps();
		});
	};

	render() {
		const {lang} = this.props;
		return (
			<div className='checkedApps'>
				{/*----------------------- alerts -----------------------------------*/}
				<Card className="checkedApps__card">
					<CardTitle className="mb-0 p-3 border-bottom bg-light">
						<button
								className="checkedApps__btn_clear btn btn-secondary"
								onClick={this.unselectAllApp}
								disabled={!this.state.checkedApps.length}
						>
							{I18n[lang].deleteAll}
						</button>
						<button
							className="btn btn-primary"
							onClick={this.props.sendCheckedApps}
							disabled={!this.state.checkedApps.length}
						>
							{I18n[lang].addAll}
						</button>
					</CardTitle>

					<CardBody>
						{
								<div className="checkedApps__body">
								{
									(() => {
										if (this.state.loading) {
											return <div className="loading">Loading...</div>;
										} else {
											const tableData = this.state.checkedApps.map((app, index) => {
												return {
													count_id: index + 1,
													id: app.id || 'none' ,
													title: [app.id, app.appLabel] || 'none',
													actions: (
														<div className="text-center">
															<Button
																onClick={() => {this.unselectApp(app.id)}}
																className="ml-1"
																color="danger"
																size="sm"
																round="true"
																icon="true"
															>
																<i className="fa fa-times"/>
															</Button>
														</div>
													),
												};
											});
											return (
												<div className="user-table">
													<ReactTable
														getProps={(state, rowInfo, column, instance) => {
															return {
																style: {
																	border: "none",
																	padding: "5px"
																}
															};
														}}
														getTheadProps={(state, rowInfo, column, instance) => {
															return {
																style: {
																	boxShadow: "none",
																	padding: "10px 0",
																	fontWeight: "600"
																}
															};
														}}
														getTheadThProps={(state, rowInfo, column, instance) => {
															return {
																style: {
																	borderRight: "none"
																}
															};
														}}
														getTdProps={(state, rowInfo, column, instance) => {
															return {
																style: {
																	borderRight: "none",
																	textAlign: "center"
																}
															};
														}}
														getTrProps={(state, rowInfo, column, instance) => {
															return {
																style: {
																	alignItems: "center"
																}
															};
														}}
														getNoDataProps={(state, rowInfo, column, instance) => {
															return {
																style: {
																	top: "100%"
																}
															};
														}}
														columns={[
															{
																Header: "#",
																accessor: "count_id",
																sortable: false,
																filterable: false,
																style: {
																	textAlign: "left",
																	fontSize: "0.7rem",
																	textTransform: "lowercase"
																},
																maxWidth: 40,

															},
															{
																Header: `${I18n[lang].appName}`,
																accessor: "title",
																sortable: false,
																filterable: false,
																minWidth: 200,
																style: {
																	textAlign: "left"
																},
																Cell: row => (
																	<div className="user-table__img">
																		<img
																			src={`${API_BASE_URL}/apps/mobileapps/download/icon/${row.value[0]}`}
																			alt="application logotype"
																			className="img-fluid mr-2 media-object"
																			width="60"
																		/>
																		<span>{row.value[1]}</span>
																	</div>
																)
															},
															{
																Header: "",
																accessor: "actions",
																sortable: false,
																filterable: false,
																maxWidth: 75
															}
														]}
														defaultPageSize={tableData.length}
														showPaginationBottom={false}
														className="-highlight"
														data={tableData}
														filterable
													/>
												</div>
											)
										}
									})()
								}
								</div>
						}
					</CardBody>
				</Card>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	alert: state.alert,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps)(CheckedAppsList)



// WEBPACK FOOTER //
// ./src/components/CheckedAppsList/CheckedAppsList.js